(ns dashboard.views.settings.organization
  (:require
   [reagent.core :as reagent]
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen]]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.button :refer [button]]))

(defn content []
  (let [state (reagent/atom (listen ::subs/organization))]
    (fn []
      [:div.divide-y.divide-gray-200
       [:div.py-6.px-4.sm:p-6.lg:pb-8
        [:div.grid.grid-cols-12.gap-6
         [:div.col-span-12.sm:col-span-6
          [input
           {:id "company-name"
            :label "Company Name"
            :default-value (:name @state)
            :auto-complete "company-name"
            :name "organization"
            :type "text"
            :on-change #(swap! state assoc :name %)}]]
         [:div.col-span-12
          [:label.block.text-sm.font-medium.text-gray-700
           {:for "url"}
           "URL"]
          [:input#url.mt-1.block.w-full.border.border-gray-300.rounded-md.shadow-sm.py-2.px-3.focus:outline-none.focus:ring-primary-500.focus:border-primary-500.sm:text-sm
           {:name "url" :type "text"}]]]]
       [:div.pt-6.divide-y.divide-gray-200
        [:div.px-4.sm:px-6
         [:div
          [:h2.text-lg.leading-6.font-medium.text-gray-900
           "Products"]
          [:p.mt-1.text-sm.text-gray-500
           "Organization level product settings."]]
         [:ul.mt-2.divide-y.divide-gray-200
          {:role "list"}
          [:li.py-4.flex.items-center.justify-between
           [:div.flex.flex-col
            [:p#privacy-option-2-label.text-sm.font-medium.text-gray-900
             "Fraud detection"]
            [:p#privacy-option-2-description.text-sm.text-gray-500
             "Add fraud detection score to your converted documents."]]
           [:button.bg-gray-200.ml-4.relative.inline-flex.flex-shrink-0.h-6.w-11.border-2.border-transparent.rounded-full.cursor-pointer.transition-colors.ease-in-out.duration-200.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500
            {:aria-describedby "fraud-detection"
             :aria-labelledby "fraud-detection-label"
             :aria-checked "false"
             :role "switch"
             :type "button"}
            [:span.translate-x-0.inline-block.h-5.w-5.rounded-full.bg-white.shadow.transform.ring-0.transition.ease-in-out.duration-200
             {:aria-hidden "true"}]]]]]
        [:div.mt-4.py-4.px-4.flex.justify-end.sm:px-6
         [button
          {:type "submit"}
          (tr :action/save)]]]])))
